import { render, staticRenderFns } from "./MediumHtmlInput.vue?vue&type=template&id=220ab74f&"
import script from "./MediumHtmlInput.vue?vue&type=script&lang=js&"
export * from "./MediumHtmlInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220ab74f')) {
      api.createRecord('220ab74f', component.options)
    } else {
      api.reload('220ab74f', component.options)
    }
    module.hot.accept("./MediumHtmlInput.vue?vue&type=template&id=220ab74f&", function () {
      api.rerender('220ab74f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-type-meduim-editor/inputs/MediumHtmlInput.vue"
export default component.exports